import cn from 'classnames';

import { ImageData, LinkData } from 'src/types/components';

import PeopleCard from '../PeopleCard';

import styles from './PeopleGrid.module.scss';

export type PeopleGridProps = {
  className?: string;
  items: Array<{
    firstName: string;
    middleName: string;
    lastName: string;
    title: string;
    email: string;
    phone: string;
    image?: ImageData;
    office: LinkData;
    url: string;
  }>;
};

const PeopleGrid = (props: PeopleGridProps): JSX.Element => {
  const { items, className } = props;

  if (items.length === 0) {
    return <></>;
  }

  return (
    <ul className={cn(styles.list, className)}>
      {items.map((item) => (
        <li key={item.url} className={styles['list-item']}>
          <PeopleCard className={styles.card} {...item} />
        </li>
      ))}
    </ul>
  );
};

export default PeopleGrid;
